import React, { useEffect, useState } from "react";
import SeoHead from "./SiteSeo";
import SiteLayout from "./SiteLayout";
import { FinalCta } from "./sections";

const API = process.env.REACT_APP_BACKEND_URL;
const PAGE = 24;
const Stars = ({ n = 5 }) => <span className="tst-stars small" aria-label={`${n} out of 5 stars`}>{"★★★★★".slice(0, n)}</span>;

function ReviewCard({ r }) {
  const [full, setFull] = useState(false);
  const abridged = r.excerpt && r.excerpt !== r.text;
  return (
    <article className="rv-card" data-testid={`review-card-${r.id}`}>
      <Stars n={r.rating || 5} />
      <p className="rv-text">{full || !abridged ? r.text : r.excerpt}</p>
      {abridged && <button type="button" className="rv-more" onClick={() => setFull((v) => !v)} data-testid={`review-toggle-${r.id}`}>{full ? "Show less" : "Read the full review"}</button>}
      <div className="rv-who"><strong>{r.name}</strong>{r.location && <span> · {r.location}</span>}</div>
    </article>
  );
}

export default function ReviewsPage() {
  const [data, setData] = useState(null);
  const [topic, setTopic] = useState("");
  const [shown, setShown] = useState(PAGE);
  useEffect(() => {
    fetch(`${API}/api/public/testimonials/all?topic=${topic}`).then((r) => r.json()).then((d) => { setData(d); setShown(PAGE); }).catch(() => setData({ items: [], topics: [], aggregate: {} }));
  }, [topic]);
  const items = data?.items || [];
  const agg = data?.aggregate || {};
  const rounded = Math.max(10, Math.floor((agg.count || 0) / 10) * 10);
  return (
    <SiteLayout>
      <SeoHead title="Hello Mortgage’s Google Reviews — Hello Mortgage Team" description="Hello Mortgage Team, based in Edmonton, AB, has helped over 250 families achieve homeownership. With glowing Google reviews praising their exceptional services, knowledgeable team, and outstanding customer service. Let's take a look at what some of the customers had to say..." path="/why-hello/reviews/" />
      <section className="hero rv-hero" data-testid="reviews-page">
        <div className="wrap rv-hero-grid">
          <div>
            <div className="eyebrow">Client reviews · straight from Google</div>
            <h1 style={{ fontSize: "clamp(2.6rem,4.6vw,4.2rem)" }}>Hello Mortgage’s Google Reviews</h1>
            <p className="rv-heat" data-testid="reviews-heat">Turning up the heat and making loans happen</p>
            <p className="rv-intro">As it turns out, people love us. But we’re not ones to brag. Instead, we like to let our clients do the talking.</p>
            <div className="rv-badge" data-testid="reviews-badge">
              <span className="tst-stars">★★★★★</span>
              <span>Over <strong>{rounded}</strong> five-star reviews</span>
              <a href={data?.google_url} target="_blank" rel="noopener noreferrer" className="textlink" data-testid="reviews-google-link">See them on Google</a>
            </div>
          </div>
          <img className="rv-fire" src="/brand/we-got-that-fire.png" alt="We got that fire — Hello Mortgage Team" />
        </div>
      </section>
      <section className="rv-body">
        <div className="wrap">
          <div className="rv-filters" role="tablist" aria-label="Filter reviews by situation" data-testid="reviews-filters">
            <button type="button" role="tab" aria-selected={!topic} className={!topic ? "on" : ""} onClick={() => setTopic("")} data-testid="reviews-filter-all">All reviews</button>
            {(data?.topics || []).map((t) => <button type="button" role="tab" key={t.key} aria-selected={topic === t.key} className={topic === t.key ? "on" : ""} onClick={() => setTopic(t.key)} data-testid={`reviews-filter-${t.key}`}>{t.label} <small>{t.count}</small></button>)}
          </div>
          <div className="rv-grid" data-testid="reviews-grid">{items.slice(0, shown).map((r) => <ReviewCard r={r} key={r.id} />)}</div>
          {shown < items.length && <div className="rv-more-wrap"><button type="button" className="btn outline" onClick={() => setShown((v) => v + PAGE)} data-testid="reviews-load-more">Show more reviews ({items.length - shown} left)</button></div>}
        </div>
      </section>
      <FinalCta text="Want a story like these? Start with a free conversation. No pressure. No mortgage-speak." />
    </SiteLayout>
  );
}
